import { MainKeys } from '../../main/main.key';
import { Places } from '../../route-consts';
/**
 * A pagina de aterrissagem.
 *
 * Publica e sem parametro. E onde cai quem chega sem sessao - ver a decisao em
 * `MainPresenter.applyParameters`.
 */
export class LandingKeys extends MainKeys {
    get place() {
        return Places.landing;
    }
}
//# sourceMappingURL=landing.key.js.map